// Copyright (c) 2016 Deere & Company

import Customer, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../../actions-list';

const updateCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

const updateCustomerCkcId = (state, action) =>
    Customer.update(state, {
        ckcId: {
            $set: action.ckcId
        }
    });

const updateCustomerId = (state, action) =>
    Customer.update(state, {
        id: {
            $set: action.id
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.READ_PRODUCT_SEARCH_CUSTOMER_SUCCESS]: updateCustomer,
        [actions.UPDATE_PRODUCT_SEARCH_CUSTOMER_CKC_ID]: updateCustomerCkcId,
        [actions.UPDATE_PRODUCT_SEARCH_CUSTOMER_ID]: updateCustomerId
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/search/reducers/customer.js